import React from 'react'
import DataGrid from '../../../../table/DataGrid'
import TextValue from '../../../../text/TextValue'
import { Box, Table, TableContainer, TableBody, TableRow, TableCell, Chip, Typography } from '@mui/material'
import groupBy from 'lodash/groupBy'
import isEmpty from 'lodash/isEmpty'
import pluralize from 'pluralize'

const TableCompareImportCurriculumElements = ({ data = [] }) => {
  return (
    <Box className='flex flex-col gap-4 pt-4'>
      <div className='h-screen-1/3 relative'>
        <DataGrid
          id='table-compare-import'
          showSetting={false}
          rows={data
            .sort((a, b) => b.code - a.code)
            .map((row, index) => ({
              ...row,
              index: index + 1,
              parents: (
                <div className=' flex flex-col gap-2 items-center justify-start'>
                  {row.parents
                    ?.filter((parent) => !parent.elementStructureId)
                    ?.map((parent, index) => (
                      <div
                        key={`index=parent-${index}`}
                        className='max-w-160px flex items-center justify-start'
                      >
                        <p className='text-primary text-xs font-bold opacity-60 text-ellipsis uppercase pr-2'>
                          {parent.level}
                        </p>
                        <p className='text-muted-foreground text-sm opacity-60 text-ellipsis'>
                          {parent.name}
                        </p>
                      </div>
                    ))}
                </div>
              ),
              element: (
                <div className='max-w-160px flex items-center justify-start'>
                  <p className='text-primary text-xs font-bold opacity-60 text-ellipsis uppercase pr-2'>
                    {row.structureName}
                  </p>
                  <p className='text-muted-foreground text-sm opacity-60 text-ellipsis'>{row.name}</p>
                </div>
              ),
              _id: row._id ? row._id : index
            }))}
          rowsPerPage={data?.length || 0}
          columns={[
            { label: '#', key: 'index', align: 'center', show: true, hide: false },
            { label: 'element', key: 'element', width: '160px', show: true, hide: false },
            { label: 'parents', key: 'parents', show: true, hide: false }
          ]}
          labelNoRows="You don't have any changes yet"
        />
      </div>
    </Box>
  )
}
export default TableCompareImportCurriculumElements
